/* eslint-disable import/prefer-default-export */
export const chooseAction = [
  {
    label: 'Transfer Sekarang',
    value: 'transfer_now',
  },
  {
    label: 'Transfer Manual',
    value: 'transfer_manual',
  },
  {
    label: 'Review',
    value: 'review',
  },
  {
    label: 'Tolak',
    value: 'tolak',
  },
]

export const listDetailWithdrawal = [
  {
    key: 'created_at',
    label: 'Tanggal',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'type',
    label: 'Jenis Transaksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'nominal',
    label: 'Jumlah',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'saldo',
    label: 'Saldo',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'action',
    label: 'Action',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
]

export const listWithdrawal = [
  {
    key: 'created_at',
    label: 'Tanggal',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'partner_name',
    label: 'Nama',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'bank_name',
    label: 'Nama Bank',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'bank_account_no',
    label: 'No Rekening',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'nominal',
    label: 'Nominal',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
  {
    key: 'status',
    label: 'Status',
    class: 'border-b-0 text-black p-1 text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
  },
]

export const statusOptionsListWithdrawal = [
  {
    value: null,
    text: 'Pilih Status',
    disabled: true,
  },
  {
    value: '',
    text: 'Semua',
  },
  {
    value: 'requested',
    text: 'Request Penarikan',
  },
  {
    value: 'on_review',
    text: 'Sedang Direview',
  },
  {
    value: 'completed',
    text: 'Disetujui',
  },
  {
    value: 'rejected',
    text: 'Ditolak',
  },
  {
    value: 'in_process',
    text: 'Diproses',
  },
]
